import { FigmaLogo } from './FigmaLogo';

export function DialogLogo() {
  return (
    <div
      className="mb-12 min-h-30 relative"
      style={{
        background:
          'radial-gradient(37.44% 109.75% at 82.64% 95.34%, rgba(10, 207, 131, 0.2) 0%, rgba(10, 207, 131, 0) 100%), radial-gradient(40.33% 118.22% at 63.8% 105.93%, rgba(26, 188, 254, 0.3) 0%, rgba(26, 188, 254, 0) 100%), radial-gradient(39.75% 116.53% at 38.2% 108.9%, rgba(162, 89, 255, 0.5) 0%, rgba(162, 89, 255, 0) 100%), radial-gradient(41.2% 120.76% at 15.5% 100%, rgba(242, 78, 30, 0.3) 0%, rgba(242, 78, 30, 0) 100%)',
      }}
    >
      <div
        className="absolute bottom-0 w-100% h-1px"
        style={{
          background: 'linear-gradient(270deg, #0ACF83 0%, #1ABCFE 39.5%, #A259FF 77.5%, #F24E1E 100%)',
        }}
      />
      <FigmaLogo className="absolute top-65% left-0 right-0 ml-auto mr-auto" />
    </div>
  );
}
